import React from 'react';
import { useSelector } from 'react-redux';
import UnderlineLink from 'components/_core/UnderlineLink';
import { getEnvVar } from 'utils/get-env-var';
import styled from 'styled-components';

const BLink = styled(UnderlineLink)`
    @media screen and (max-width: 530px) {
        display: none;
    }
`;

export const BlogLink = () => {
    const isSubscriber = useSelector(state => state.user.userData.isSubscriber);

    if (isSubscriber) {
        return null;
    }

    return (
        <BLink to={`${getEnvVar('ROOT_ROUTE')}/blog`}>Blog</BLink>
    );
};
